import React, { useState } from 'react';
import { IconButton } from '@mui/material';
import HistoryIcon from '@mui/icons-material/History';
import { useTranslation } from 'react-i18next';
import { CustomTooltip } from 'app/components/Common/Tooltips';
import { CandidateHistoryModal } from './CandidateHistoryModal';

type TagsCandidateHistoryCellProps = {
  row: {
    candidateId?: number;
    brandId?: number;
  };
};

export const TagsCandidateHistoryCell = ({ row }: TagsCandidateHistoryCellProps) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const candidateId = row?.candidateId;
  const brandId = row?.brandId;

  if (!candidateId || !brandId) {
    return null;
  }

  return (
    <>
      <CustomTooltip
        tooltipContent={t('tagsManagement.candidateTags.columns.history')}
        placement="bottom-start"
        isInlineContent={true}
      >
        <IconButton
          color="secondary"
          size="small"
          onClick={event => {
            event.stopPropagation();
            document.body.setAttribute('data-dialog', 'true');
            document.body.setAttribute('data-candidate-history-dialog', 'true');
            setOpen(true);
          }}
          aria-label={t('tagsManagement.candidateTags.columns.history')}
        >
          <HistoryIcon fontSize="small" />
        </IconButton>
      </CustomTooltip>
      {open && (
        <CandidateHistoryModal
          open={open}
          onClose={() => {
            setOpen(false);
            document.body.removeAttribute('data-dialog');
            document.body.removeAttribute('data-candidate-history-dialog');
          }}
          candidateId={candidateId}
          brandId={brandId}
        />
      )}
    </>
  );
};
